import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["container", "addButton", "template"]

  connect() {
    var parsedMax = parseInt(this.data.get("maxEntriesValue"))
    this.maxEntries = Number.isNaN(parsedMax) ? 0 : parsedMax
    var parsedMin = parseInt(this.data.get("minEntriesValue"))
    this.minEntries = Number.isNaN(parsedMin) ? 1 : parsedMin
    this.nextIndex = this.containerTarget.querySelectorAll("[data-fieldset-entry]").length
    this.updateButtons()
  }

  addEntry() {
    const template = this.templateTarget
    const clone = template.content.cloneNode(true)
    const html = clone.firstElementChild.outerHTML.replace(/__INDEX__/g, this.nextIndex)
    const wrapper = document.createElement("div")
    wrapper.innerHTML = html
    this.containerTarget.appendChild(wrapper.firstElementChild)
    this.nextIndex++
    this.updateEntryLabels()
    this.updateButtons()
  }

  removeEntry(event) {
    const entry = event.currentTarget.closest("[data-fieldset-entry]")
    const currentCount = this.containerTarget.querySelectorAll("[data-fieldset-entry]").length
    if (currentCount <= this.minEntries) return
    entry.remove()
    this.updateEntryLabels()
    this.updateButtons()
  }

  updateEntryLabels() {
    const entries = this.containerTarget.querySelectorAll("[data-fieldset-entry]")
    entries.forEach(function (entry, idx) {
      var label = entry.querySelector("[data-entry-label]")
      if (label) label.textContent = "Entry " + (idx + 1)
    })
  }

  updateButtons() {
    var currentCount = this.containerTarget.querySelectorAll("[data-fieldset-entry]").length

    if (this.hasAddButtonTarget && this.maxEntries > 0) {
      if (currentCount >= this.maxEntries) {
        this.addButtonTarget.classList.add("hidden")
      } else {
        this.addButtonTarget.classList.remove("hidden")
      }
    }

    var removeButtons = this.containerTarget.querySelectorAll("[data-action*='fieldset-entries#removeEntry']")
    removeButtons.forEach(function (btn) {
      if (currentCount <= this.minEntries) {
        btn.classList.add("hidden")
      } else {
        btn.classList.remove("hidden")
      }
    }.bind(this))
  }
}
